export const sortOptions = [
    {title: "defaultOrder", value: {field: "", order: ""}},
    {title: "priceHighToLow", value: {field: "price", order: "desc"}},
    {title: "priceLowToHigh", value: {field: "price", order: "asc"}},
    {title: "newestFirst", value: {field: "date", order: "desc"}},
    {title: "oldestFirst", value: {field: "date", order: "asc"}},
];
